<template>
    <div class="w-full flex flex-col">
        <div class="flex flex-row justify-between items-center gap-2">
            <div class="flex flex-row items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                    <g clip-path="url(#clip0_848_23983)">
                        <path
                            d="M1.56213 15.2019C1.13672 15.2019 0.776648 15.0545 0.481907 14.7598C0.187166 14.4651 0.0397949 14.105 0.0397949 13.6796V4.93459C0.0397949 4.50918 0.187166 4.14911 0.481907 3.85437C0.776648 3.55963 1.13672 3.41226 1.56213 3.41226H5.0925V1.98718C5.0925 1.56177 5.23987 1.2017 5.53461 0.906956C5.82935 0.612214 6.18943 0.464844 6.61484 0.464844H9.46499C9.8904 0.464844 10.2505 0.612214 10.5452 0.906956C10.84 1.2017 10.9873 1.56177 10.9873 1.98718V3.41226H14.5177C14.9431 3.41226 15.3032 3.55963 15.5979 3.85437C15.8927 4.14911 16.04 4.50918 16.04 4.93459V13.6796C16.04 14.105 15.8927 14.4651 15.5979 14.7598C15.3032 15.0545 14.9431 15.2019 14.5177 15.2019H1.56213ZM1.56213 13.9387H14.5177C14.5825 13.9387 14.6419 13.9117 14.6958 13.8577C14.7498 13.8038 14.7769 13.7444 14.7769 13.6796V4.93459C14.7769 4.86975 14.7498 4.81038 14.6958 4.75649C14.6419 4.70245 14.5825 4.67543 14.5177 4.67543H1.56213C1.49729 4.67543 1.43792 4.70245 1.38403 4.75649C1.32999 4.81038 1.30297 4.86975 1.30297 4.93459V13.6796C1.30297 13.7444 1.32999 13.8038 1.38403 13.8577C1.43792 13.9117 1.49729 13.9387 1.56213 13.9387ZM6.35568 3.41226H9.72415V1.98718C9.72415 1.92234 9.69713 1.86297 9.6431 1.80907C9.5892 1.75504 9.52983 1.72802 9.46499 1.72802H6.61484C6.55 1.72802 6.49063 1.75504 6.43673 1.80907C6.3827 1.86297 6.35568 1.92234 6.35568 1.98718V3.41226Z"
                            fill="#696969" />
                    </g>
                    <defs>
                        <clipPath id="clip0_848_23983">
                            <rect width="16" height="16" fill="white" transform="translate(0.0400391)" />
                        </clipPath>
                    </defs>
                </svg>
                <h4 class="nxp-review-title">Experiências</h4>
            </div>

            <button class="nxp-review-title-action" type="button" @click="$router.push({ name: 'edit-experiences' })">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                    <path
                        d="M4.54 15.4993H5.46625L13.6633 7.30227L12.7371 6.37602L4.54 14.5731V15.4993ZM3.45667 16.5827V14.1164L13.8237 3.73331C13.9358 3.61886 14.0565 3.5374 14.1856 3.48893C14.3148 3.44032 14.4501 3.41602 14.5917 3.41602C14.7333 3.41602 14.8685 3.43872 14.9973 3.48414C15.1262 3.52956 15.251 3.60997 15.3717 3.72539L16.306 4.65164C16.4215 4.77234 16.5032 4.89734 16.5512 5.02664C16.5993 5.15595 16.6233 5.28907 16.6233 5.42602C16.6233 5.57199 16.5981 5.71129 16.5475 5.84393C16.4968 5.97657 16.4163 6.09782 16.306 6.20768L5.92292 16.5827H3.45667ZM13.1921 6.84727L12.7371 6.37602L13.6633 7.30227L13.1921 6.84727Z"
                        fill="#4F4F4F" />
                </svg>
                Editar
            </button>
        </div>
        <hr class="custom-hr my-2 mb-4" />

        <div v-if="show()" class="flex flex-col px-6">
            <div class="flex flex-col space-y-1 py-4" v-for="(experience, index) in experiencies"
                :key="`step-${index}`">
                <div class="nxp-review-experiencies-title" v-if="experience.business_role || experience.company">
                  {{ [experience.business_role, experience.company].filter(Boolean).join(' - ') }}
                </div>

                <div class="nxp-review-experiencies-subtitle" v-if="
                    experience.from_date || experience.to_date != null
                ">
                    <b></b>
                    {{
                        (experience.from_date) ?
                            experience.from_date
                                .concat(` até ${experience.is_current ? 'Atualmente' : experience.to_date}`)
                                .concat(
                                    experience.is_current
                                        ? ''
                                        : ` (${experience.period})`
                                )
                            :
                            (
                                ((experience.from_date === null || experience.from_date === undefined) && experience.to_date)
                                    ? 'Início Não Informado - ' + experience.to_date
                                    : experience.from_date + ' - Não Informado')
                    }}
                </div>
                <div class="nxp-review-experiencies-description" v-if="
                    experience.description != null ||
                    experience.description != undefined
                ">
                    {{ experience.description }}
                </div>
                <div v-if="experiencies.length > (index + 1)" class="flex w-full h-4"></div>
                <hr v-if="experiencies.length > (index + 1)" class="custom-hr" />
            </div>
        </div>

        <div v-else class="w-full flex flex-col items-center justify-center space-y-4 py-8">
            <p class="nxp-review-no-data-text">
                Sem experiências listadas ainda, <br />inclua para valorizar suas conquistas profissionais
            </p>
            <button class="nxp-review-no-data-btn" type="button" @click="$router.push({ name: 'edit-experiences' })">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                    <path
                        d="M8.22616 8.75597H2.58252V7.24325H8.22616V1.59961H9.73888V7.24325H15.3825V8.75597H9.73888V14.3996H8.22616V8.75597Z"
                        fill="#4F4F4F" />
                </svg>
                Adicionar Experiências
            </button>
        </div>
    </div>
</template>

<script>
import { get } from 'lodash';
import { mapState } from 'vuex';

import EmptyDetailCard from '@/components/dashboard/profile-detail/EmptyDetailCard';

export default {
    name: 'experience-detail-card',
    computed: {
        ...mapState('experience', ['experiencies']),
        ...mapState('company', ['company']),

        color() {
            return get(this.$store, 'state.company.base_hexcolor', '#1551b1');
        },
    },
    methods: {
        show() {
            return this.experiencies.length > 0
        }
    },

    components: {
        EmptyDetailCard
    },
}
</script>

<style lang="scss">
@import '@/assets/scss/talent/components/experiencedetailcard.scss';

hr {
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    border: none;
}
</style>